import { render, staticRenderFns } from "./ActionLlegadaDePartes.vue?vue&type=template&id=a237be8a&lang=pug"
import script from "./ActionLlegadaDePartes.vue?vue&type=script&lang=js"
export * from "./ActionLlegadaDePartes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports